export default __webpack_public_path__ + "static/media/invoiceIcon.3d3eb07c.svg";